import { formatPhoneNumber } from '../../util/phoneNumber';

// Why replies go where they go, from automatic_reply.source.
export const replySourceText = (automaticReply) => {
  if (!automaticReply) return '';
  const by = automaticReply.approved_by ? ` by ${automaticReply.approved_by}` : '';
  switch (automaticReply.source) {
    case 'sender':
      return `number on the fax, confirmed for this line${by}`;
    case 'referral':
      return `confirmed for this referral${by}`;
    case 'matches_document':
      return 'number on the fax';
    case 'line':
      return 'line the fax came from';
    case 'line_override':
    case 'sender_default':
      return 'set up for this line';
    default:
      return '';
  }
};

// One sentence for the toast after a status change, from the status row's
// reply_outcome. null when the status sends no reply.
export const replyOutcomeText = (replyOutcome) => {
  if (!replyOutcome) return null;
  switch (replyOutcome.state) {
    case 'sending':
      return replyOutcome.destination
        ? `Reply faxing to ${formatPhoneNumber(replyOutcome.destination)}.`
        : 'Reply faxing to the referring office.';
    case 'held':
      return 'The reply will send once someone chooses the reply fax number.';
    case 'not_set_up':
      return 'No reply sent: this line isn\'t set up for automatic replies.';
    default:
      return null;
  }
};
